import React, { createContext, useState, useEffect } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import Loader from '../pages/landing/loder/Loader';
import { UserAuth } from '../pages/auth/Auth';
const Header = React.lazy(() => import('../layouts/Header'));
const Sidebar = React.lazy(() => import('../layouts/Sidebar'));
const Footer = React.lazy(() => import('../layouts/Footer'));


function ProtectedRoute() {

    const { isLoggedIn } = UserAuth();
    if (!isLoggedIn) {
        return <Navigate to="/login" replace />;
    }
    return (
        <Outlet />
    )
};

export default ProtectedRoute